import request from '@/utils/request'

// 查询字典数据列表
export function listData(query) {
  return request({
    url: '/sys/dict/data/',
    method: 'get',
    params: query
  })
}

// 查询字典数据详细
export function getData(dictCode) {
  return request({
    url: '/sys/dict/data/' + dictCode,
    method: 'get'
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/sys/dict/data/',
    method: 'get',
    params: {
      page: 1,
      limit: 9999,
      dictLabel: '',
      dictType: dictType,
      status: '1'
    }
  })
}

// 新增字典数据
export function addData(data) {
  return request({
    url: '/sys/dict/data/',
    method: 'post',
    data: data
  })
}

// 修改字典数据
export function updateData(data) {
  return request({
    url: '/sys/dict/data/',
    method: 'put',
    data: data
  })
}

// 删除字典数据
export function delDict(dictCode) {
  return request({
    url: '/sys/dict/data/?ids='+dictCode,
    method: 'delete'
  })
}




// WEBPACK FOOTER //
// ./src/api/sys/dict/data.js